// extracted by mini-css-extract-plugin
export var floatToggleBtn = "index-module--floatToggleBtn--6d9f9";
export var floatToggleBtnContent = "index-module--floatToggleBtnContent--06c7d";
export var lodgingSlider = "index-module--lodgingSlider--b9dde";
export var lodgingSliderDesktop = "index-module--lodgingSliderDesktop--95624";
export var mapWrapper = "index-module--mapWrapper--486ce";
export var sliderWrapper = "index-module--sliderWrapper--fe0ac";